import { createFileRoute, redirect } from "@tanstack/react-router";

// A bare profile link opens on Memory.
export const Route = createFileRoute("/_app/_main/team/$employeeId/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/team/$employeeId/memory", params, replace: true });
  },
});
